// A post that uses a licensed song (D-090), so the brand knows before approving it.
export function LicensedSong({ post }: { post: { audioType?: string | null } }) {
  if (post.audioType !== "MUSIC") return null;
  return (
    <span className="pill" title="Instagram says this post's sound is a licensed song">
      Uses a licensed song
    </span>
  );
}
